import { filterTag_template } from "../../../../../../js/components/templates/filterTag_template";
import { filterUser_template } from "../../../../../../js/components/templates/filterUser_template";
import { imageWidget_template } from "../../../../../../js/components/templates/imageWidget_template";
import { DragAndDropHandler } from "../../../../../../js/utils/DragAndDropHandler";
import { multipleSelector_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { vnTemplate } from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { validationsList_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {infoButton_template} from "../../../../../valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;
declare var Dropzone: any;
let myDropzone = null;

export default class videoPickerEdit_template extends vnTemplate {
    public parent: any;
    public filterUser_producer: filterUser_template;
    public filterTag: filterTag_template;
    public filterCategory: multipleSelector_template;
    public thumbnailImageWidget: imageWidget_template;
    public validations: validationsList_template;
    protected subtitlesTypesToolTip: infoButton_template;
    protected subtitlesAutoGenToolTip: infoButton_template;
    protected subtitlesTypesTooltipContent;
    protected subtitlesAutoGenTooltipContent;

    public setParent(value: any) {
        this.parent = value;
    }

    protected getTemplateHtml(): string {
        return `<div class="w-img-picker-form" data-bind="css: { 'is-visible': videoPickerEditShown }">
                    <div class="img-picker-form">
                        <div class="form-header">
                            <div class="section-title">
                                <h3 class="section-title">Edit Video</h3>
                            </div>
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                        ${this.validations.getHtmlBuild()}
                        <div class="form-body">
                            <div class="form-group">
                            <!-- ko if: url -->
                                <button class="btn-form icon  i-full-size" type="button" data-bind="click : onClickVideoPreview">See video</button>
                            <!-- /ko -->
                            </div>

                            <div class="form-group">
                                <dl class="double-list">
                                    <dt><span>Duration</span></dt>
                                    <dd><span data-bind="text: length"></span></dd>
                                    <dt><span>file size</span></dt>
                                    <dd><span data-bind="text: readableVideoSize()"></span></dd>
                                    <dt><span>dimension</span></dt>
                                    <dd><span class="lower-case" data-bind="text: width()+ 'px' + ' x ' + height() + 'px'"></span></dd>
                                    <dt><span>ratio</span></dt>
                                    <dd><span data-bind="text: ratio"></span></dd>
                                    <dt><span>mime</span></dt>
                                    <dd><span class="lower-case" data-bind="text: mimeType"></span></dd>

                                </dl>
                            </div>



                            <div class="form-group" style="margin-bottom: 0;">
                                <label class="form-label" for="">Thumbnail</label>
                                <!-- ko if: thumbnailError -->
                                    <small style="color:#ff385a;display: block;position: static" data-bind="text: thumbnailErrorMessage" class="form-error"></small>
                                <!-- /ko -->
                            </div>

                            <div class="form-group img">
                                ${this.thumbnailImageWidget.getHtmlBuild()}
                            </div>



                            <div class="form-sub-title">Video Information</div>

                            <div class="form-group">
                                <label class="form-label" for="">title</label>
                                <input class="input-text" type="text" data-bind="value: title">
                                <!-- ko if: titleError -->
                                <small style="color:#ff385a;" data-bind="text: titleErrorMessage" class="form-error"></small>
                                <!-- /ko -->
                            </div>

                            <div class="form-group">
                                <label class="form-label" for="_video_description_">description</label>
                                <textarea rows="4" id="_video_description_" data-bind="textInput: description" ></textarea>
                            </div>

                            <div class="form-group" data-bind="if: embargoPermissions()">
                                <input type="checkbox" data-bind="checked: isUnderEmbargo" id="video-under-embargo">
                                <label for="video-under-embargo" class="form-label icon i-check">Under Embargo</label>
                            </div>

                            <div class="form-group">
                                <label for="producer" class="form-label">Producer</label>
                                ${this.filterUser_producer.getHtmlBuild()}
                            </div>

                            <div class="form-sub-title">Categorization</div>

                            <div class="form-group">
                                <label for="idContentType" class="form-label form-label-box">Content Type</label>
                                <select id="idContentType" data-bind="options: contentTypes, optionsText: 'name', value: idContentType, optionsValue: 'id'"></select>
                            </div>

                             <div class="form-group" style="margin-bottom: 4rem;">
                                <hr class="form-hr" />
                            </div>

                            <div class="form-group" style="align-items: flex-start;">
                                <label class="form-label" style="width: auto;">Categories</label>
                                ${this.filterCategory.getHtmlBuild()}
                            </div>
                            <div class="form-group w-radio" style="margin-top: -5rem;" data-bind="foreach: selectedCategories, childrenComplete : handleDragAndDrop($element, selectedCategories ,'.category-element')">
                                <div class="btn-selection category-element">
                                    <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                    <input type="radio" name="category_vp" data-bind="attr: { value: $data.category.id, id: 'category_vp_' + $data.category.id, checked: $parent.idPrimaryCategory() == $data.category.id ? $parent.idPrimaryCategory() : null }, event: { click: $parent.onClickSetSelectedPrimaryCategory }">
                                    <label class="form-label" data-bind="text: $data.category.name, attr: { for: 'category_vp_' + $data.category.id }"></label>
                                    <button class="icon i-x-after" type="button" data-bind="visible: true, event: { click: $parent.onClickDeleteSelectedCategory }"></button>
                                </div>
                            </div>

                            <div class="form-group" >
                                <hr class="form-hr" />
                            </div>

                            <div class="form-group" style="align-items: flex-start;">
                                <label class="form-label" style="width: auto;">Tags</label>
                                ${this.filterTag.getHtmlBuild()}
                            </div>

                            <div class="form-group" data-bind="foreach: selectedTags, childrenComplete : handleDragAndDrop($element, selectedTags ,'.tag-element')">
                                <div class="btn-selection tag-element">
                                    <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                    <input type="radio" name="tag_vp" data-bind="attr: { value: $data.tag.id, id: 'tag_vp_' + $data.tag.id, checked: $parent.idPrimaryTag() == $data.tag.id ? $parent.idPrimaryTag() : null }, event: { click: $parent.onClickSetSelectedPrimaryTag }">
                                    <label class="form-label" data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset, attr: { for: 'tag_vp_' + $data.tag.id }"></label>
                                    <button class="icon i-x-after" type="button" data-bind="visible: true, event: { click: $parent.onClickDeleteSelectedTag }"></button>
                                </div>
                            </div>

                            <div class="form-sub-title">Subtitles</div>

                            <div class="form-group row" style="justify-content: flex-start">
                                <div id="dropzone-2">
                                    <div id="my-drop-zone-2" class="dropzone" style="display: grid;">
                                        <button class="btn secondary icon i-upload" type="button" style="pointer-events: none">Upload Subtitles</button>
                                    </div>
                                    <button class="btn secondary icon i-settings" type="button" data-bind="event: { click: onClickAutoGenerateSubtitles }">Automatically Generate Subtitles</button>
                                    <div class="w-tooltips-adv pos-far-left short">${this.subtitlesAutoGenToolTip.getHtmlBuild()}</div>
                                </div>
                            </div>


                            <!-- ko if: subtitlesFiles().length -->
                            <div class="form-group">
                                <table class="list-action subtitles">
                                    <thead>
                                        <tr>
                                            <th><span>URL</span></th>
                                            <th><span>Language</span></th>
                                            <th><span style="display: flex; flex-direction: row;justify-content: center;align-items: center; margin-left: 10px">Type <div class="w-tooltips-adv pos-far-left short">${this.subtitlesTypesToolTip.getHtmlBuild()}</div></span></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody  data-bind="foreach: subtitlesFiles">
                                        <tr>
                                            <td>
                                                <span data-bind="text: $data.urlHuman" style="width: 142px;display: block;word-break: break-all; text-transform: none;"></span>
                                                <input id="subtitlesUrls[]" data-bind="value: $data.url" type="hidden">
                                                <input id="subtitlesSizes[]" data-bind="value: $data.sizeHuman" type="hidden">
                                                <input id="subtitlesMimeTypes[]" data-bind="value: $data.mimeType" type="hidden">
                                            </td>
                                            <td>
                                                <select id="subtitlesLanguages[]" data-bind="options: $parent.subtitlesLanguages, optionsText: 'name', value: $data.idLanguage, optionsValue: 'id', optionsAfterRender: $parent.setOptionDisable"></select>
                                            </td>
                                            <td>
                                                <select id="subtitlesTypes[]" data-bind="options: $parent.subtitlesTypes, optionsText: 'name', value: $data.type, optionsValue: 'id', optionsAfterRender: $parent.setOptionDisable"></select>
                                            </td>

                                                                               <td>
                                        <div style="display: flex;">
                                            <button class="btn border only-icon icon border highlight i-download" type="button" data-bind="click: $parent.onClickDownloadSubtitle, hidden: $data.url == 'auto-generated'">
                                                <span class="hidden-text">Download</span>
                                            </button>
                                            <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="click: $parent.onClickDeleteSubtitle">
                                                <span class="hidden-text">Delete</span>
                                            </button>
                                        </div>
                                    </td>


                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- /ko -->

                        </div>

                        <div class="form-footer">
                            <button type="button" class="btn icon i-cancel" data-bind="event: { click: onClickCancel }">Cancel</button>
                            <div class="insert-dropdown">
                                <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert Selected <br>and Save</span></button>
                                <div class="insert-dropdown-list">
                                    <button class="btn-icon icon i-ins-ind" type="button" data-bind="event: { click: onClickSave.bind($data, 'insert-save') }" title="Insert Individually" type="button"><span>Individually</span></button>
                                </div>
                            </div>

                            <button type="button" class="btn highlight icon i-save" data-bind="event: { click: onClickSave.bind($data, 'save')  }">Save</button>
                        </div>
                    </div>
                </div>
                `;
    }

    protected initPartial(): void {
        this.validations = new validationsList_template(
            "validationList_video",
            this.getTemplateViewModel(),
            this.caller,
        );

        this.thumbnailImageWidget = new imageWidget_template("video_thumbnail", this.getTemplateViewModel(), this);
        this.thumbnailImageWidget.setMode("single-select");
        this.filterUser_producer = new filterUser_template(
            "filterUser_producer",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.filterUser_producer.setUniqueIdentifier("producerId");
        this.filterTag = new filterTag_template("filterVideoTagEdit", this.getTemplateViewModel(), this.caller);

        this.filterCategory = new multipleSelector_template(
            "filterVideoCategoryEdit",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.filterCategory.setFilterContainerClass("margin-neg");
        this.filterCategory.setSelectAllEnabled(false);
        this.filterCategory.setSearchEnabled(false);
        this.filterCategory.setLabel("Categories");

        this.subtitlesTypesTooltipContent = `
            <ul>
                <li>Non-SDH: Meant for hearing audiences. The only transcribed element of non-SDH subtitles is dialogue.</li>
                <li>SDH: Optimized for the deaf and hard of hearing. These subtitles assume the end user cannot hear the dialogue and include important non-dialogue information such as sound effects, music, and speaker identification.</li>
                <li>Forced Narrative: Clarifies communications or alternate languages meant to be understood by the viewer. Inclusion is forced unless another subtitle file is activated.</li>
            </ul>`
        this.subtitlesTypesToolTip = new infoButton_template('subtitlesTypesToolTip', this.getTemplateViewModel(), this.caller)
        this.subtitlesTypesToolTip.setTitle('Subtitle Type');
        this.subtitlesTypesToolTip.setContent(this.subtitlesTypesTooltipContent);

        this.subtitlesAutoGenTooltipContent = `<p>Subtitle files will be queued for automatic generation by an external service as configured on save of the video. Once generated, the subtitle files will become available on the website without the need for user intervention.</p>`;
        this.subtitlesAutoGenToolTip = new infoButton_template('subtitlesAutoGenToolTip', this.getTemplateViewModel(), this.caller)
        this.subtitlesAutoGenToolTip.setTitle('Automatically Generated Subtitles');
        this.subtitlesAutoGenToolTip.setContent(this.subtitlesAutoGenTooltipContent);
    }

    protected buildViewModel(): any {
        let self = this;

        const viewModel = {
            videoPickerEditShown: ko.observable(false),
            target: ko.observable(null),
            id: ko.observable(null),
            title: ko.observable(null),
            titleError: ko.observable(false),
            titleErrorMessage: ko.observable("Title is required"),
            description: ko.observable(null),
            url: ko.observable(null),
            length: ko.observable(null),
            thumbnail: ko.observable(null),
            thumbnailError: ko.observable(false),
            thumbnailErrorMessage: ko.observable("Thumbnail image is required"),
            size: ko.observable(null),
            mimeType: ko.observable(null),
            width: ko.observable(null),
            height: ko.observable(null),
            ratio: ko.observable(null),
            isUnderEmbargo: ko.observable(null),
            dateCreated: ko.observable(null),
            dateUpdated: ko.observable(null),
            videoCardElement: ko.observable(null),
            producer: ko.observable({}),
            idProducer: ko.observable(null),
            selectedTags: ko.observableArray([]),
            idPrimaryTag: ko.observable(null),
            categories: ko.observableArray([]),
            selectedCategories: ko.observableArray([]),
            idPrimaryCategory: ko.observable(null),
            contentTypes: ko.observableArray([]),
            idContentType: ko.observable(null),
            subtitlesFiles: ko.observableArray([]),
            subtitlesLanguages: ko.observableArray([]),
            // subtitlesTypes: ko.observableArray([
            //     { id: null, name: "Select an Option" },
            //     { id: "Non-SDH", name: "Non-SDH" },
            //     { id: "SDH", name: "SDH" },
            //     { id: "Forced Narrative", name: "Forced Narrative" },
            // ]),
            subtitlesTypes: ko.observableArray([
                //{ id: null,               name: "Select an Option", disable: ko.observable(true)},
                { id: "Non-SDH",          name: "Non-SDH",          disable: ko.observable(false)},
                { id: "SDH",              name: "SDH",              disable: ko.observable(true)},
                { id: "Forced Narrative", name: "Forced Narrative", disable: ko.observable(true)},
            ]),
            setOptionDisable: function(option, item) {
                ko.applyBindingsToNode(option, {disable: item.disable}, item);
            },
            onClickCancel: (data, event) => {
                this.onClickCancel();
            },
            onClickSave: (param, data, event) => {
                this.onClickSave(param);
            },
            onClickPreviewVideo: (data) => this.onClickPreviewVideo(data),
            thumbnailUrl: (data) => this.thumbnailUrl(),
            onClickVideoPreview: (data) => this.onClickVideoPreview(data),
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
            onClickDeleteSelectedTag: function (data, event) {
                self.onClickDeleteSelectedTag(data);
            },
            onClickSetSelectedPrimaryTag: function (data, event) {
                self.setSelectedPrimaryTag(data);
                return true;
            },
            onClickDeleteSelectedCategory: function (data, event) {
                self.onClickDeleteSelectedCategory(data);
            },
            onClickSetSelectedPrimaryCategory: function (data, event) {
                self.setSelectedPrimaryCategory(data);
                return true;
            },
            onClickDeleteSubtitle: function (data) {
                self.deleteSubtitle(data);
            },
            onClickDownloadSubtitle: function (data) {
                self.downloadSubtitle(data.url);
            },
            onClickAutoGenerateSubtitles: (data) => {
                let subtitlesFiles = self.getTemplateViewModel().subtitlesFiles();
                let subtitlesFile = {
                    id: null,
                    title: "auto-generated",
                    url: "auto-generated",
                    urlHuman: "Queued for automatic generation",
                    size: 0,
                    sizeHuman: this.formatBytes(0),
                    mimeType: "text/vtt",
                    idLanguage: 1,
                    type: "Non-SDH",
                };
                subtitlesFiles.push(subtitlesFile);
                self.getTemplateViewModel().subtitlesFiles(subtitlesFiles);
            },
        };

        let readableVideoSize = ko.pureComputed(() => {
            if (viewModel.size() != null) {
                return this.formatBytes(viewModel.size());
            }
            return "";
        });

        let permissions = ko.pureComputed(() => {
            return this.parent.getPermissions();
        });

        const embargoPermissions = ko.pureComputed(() => {
            const permissions = this.parent.getPermissions()["article_edit_embargo"];
            const { read = false, write = false } = permissions || {};

            //return { read, write };
            return write;
        });

        return { ...viewModel, readableVideoSize, permissions, embargoPermissions };
    }

    public clearData() {
        this.getTemplateViewModel()
            .id(null)
            .title(null)
            .description(null)
            .url(null)
            .length(null)
            .thumbnail(null)
            .size(null)
            .width(null)
            .height(null)
            .ratio(null)
            .mimeType(null)
            .isUnderEmbargo(null)
            .dateCreated(null)
            .dateUpdated(null)
            .producer(null)
            .idProducer(null)
            .selectedCategories([])
            .idPrimaryCategory(null)
            .selectedTags([])
            .idPrimaryTag(null)
            .idContentType(null)
            .subtitlesFiles([]);

        this.thumbnailImageWidget.clearImage();
        this.validations.clearMessages();
    }

    public setData({
        id,
        title,
        description,
        url,
        length,
        size,
        thumbnail,
        width,
        height,
        ratio,
        mimeType,
        isUnderEmbargo,
        dateCreated,
        dateUpdated,
        details = null,
        videoTags = [],
        videoCategories = [],
        videoSubtitles = [],
    }, extraInfo?) {
        let producer = details !== null && details.producer !== null ? details.producer : null;
        let producerFullName =
            producer !== null && producer.valnet_user !== null && producer.valnet_user.fullNameAndLogin !== null
                ? producer.valnet_user.fullNameAndLogin
                : null;
        let producerId = producer !== null && producer.id !== null ? producer.id : null;
        let idPrimaryTag = details !== null && details.idPrimaryTag !== null ? details.idPrimaryTag : null;
        let idPrimaryCategory =
            details !== null && details.idPrimaryCategory !== null ? details.idPrimaryCategory : null;
        let idContentType = details !== null && details.idContentType !== null ? details.idContentType : null;

        let tags = [];
        if (videoTags) {
            videoTags.forEach((t) => {
                if (t.tag.id != null) {
                    tags.push(t);
                }
            });
        }

        let categories = [];
        if (videoCategories) {
            videoCategories.forEach((c) => {
                if (c.category.id != null) {
                    categories.push(c);
                }
            });
        }

        this.getTemplateViewModel().producer(producer);
        this.getTemplateViewModel().filterUser_producer.users(producer);
        this.getTemplateViewModel().filterUser_producer.user(producerFullName);
        this.getTemplateViewModel().filterUser_producer.idUser(producerId);

        this.getTemplateViewModel()
            .id(id)
            .title(title)
            .description(description)
            .url(url)
            .length(length)
            .thumbnail(thumbnail)
            .size(size)
            .width(width)
            .height(height)
            .ratio(ratio)
            .mimeType(mimeType)
            .isUnderEmbargo(isUnderEmbargo)
            .dateCreated(dateCreated)
            .dateUpdated(dateUpdated)
            .producer(producer)
            .idPrimaryTag(idPrimaryTag)
            .selectedTags(tags)
            .idPrimaryCategory(idPrimaryCategory)
            .selectedCategories(categories)
            .idContentType(idContentType);

        this.setSelectedCategories(categories);
        if (thumbnail) {
            this.thumbnailImageWidget.setImage(thumbnail);
        }

        this.getTemplateViewModel().subtitlesFiles([]);
        let subtitles = [];
        if (videoSubtitles) {
            videoSubtitles.forEach((s) => {
                if (s.idVideo && (s.id !== null || s.idVideo != null)) {
                    subtitles.push(s);
                }
            });
        }
        this.generateDropzoneSubtitles(videoSubtitles, extraInfo);
    }

    public getVideo() {
        const thumbnail = this.thumbnailImageWidget.getImage();
        const vm = this.getTemplateViewModel();
        const video = {
            id: vm.id(),
            title: vm.title(),
            description: vm.description(),
            url: vm.url(),
            length: vm.length(),
            thumbnail: thumbnail,
            size: vm.size(),
            width: vm.width(),
            height: vm.height(),
            ratio: vm.ratio(),
            mimeType: vm.mimeType(),
            isUnderEmbargo: vm.isUnderEmbargo(),
            dateCreated: vm.dateCreated(),
            dateUpdated: vm.dateUpdated(),
            producer: vm.producer(),
            idPrimaryTag: vm.idPrimaryTag(),
            selectedTags: vm.selectedTags(),
            idPrimaryCategory: vm.idPrimaryCategory(),
            selectedCategories: vm.selectedCategories(),
            idContentType: vm.idContentType(),
            subtitlesFiles: vm.subtitlesFiles(),
        };

        return video;
    }

    public setVideoData(video) {
        this.setData(video);
    }

    protected getTemplateName(): string {
        return "videoPickerEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    public toggleModal() {
        this.getTemplateViewModel().videoPickerEditShown(!this.getTemplateViewModel().videoPickerEditShown());
    }

    public show() {
        this.getTemplateViewModel().videoPickerEditShown(true);
    }

    public hide() {
        this.getTemplateViewModel().videoPickerEditShown(false);
    }

    public isShown() {
        return this.getTemplateViewModel().videoPickerEditShown() === true;
    }

    private unique(arr, keyProps) {
        const kvArray = arr.map(entry => {
        const key = keyProps.map(k => entry[k]).join('|');
        return [key, entry];
        });
        const map = new Map(kvArray);
        return Array.from(map.values());
    }

    public onClickSave(param): any {
        let videoCardElement = this.getVideoCardElement();
        let newVideoData = this.getVideo();
        let target = this.parent.getTarget();

        let videoSubtitles = this.getTemplateViewModel().subtitlesFiles();
        let videoSubtitlesValid = this.unique(this.getTemplateViewModel().subtitlesFiles(), ['idLanguage', 'type']);

        if (videoCardElement && videoSubtitlesValid.length == videoSubtitles.length) {
            //Hide video picker parent in this case

            if (this.isFormValid()) {
                this.caller.replaceOrUpdateVideoCardElement(videoCardElement, newVideoData, target);
                this.saveVideo("");
                this.setVideoCardElement(null);

                this.parent.hide();
            }
            return;
        }

        if (this.isFormValid()) {
            this.saveVideo(param);
        }
    }

    public onClickCancel(): any {
        this.clearData();
        this.hide();
        this.clearFileInput();
        this.resetFieldValidations();
    }

    public editImage(target?, viewMode?): any {
        this.caller.showImagePicker(viewMode, target);
        let image = null;
        if (target == "video_thumbnail") {
            image = this.thumbnailImageWidget.getImage();
            this.getTemplateViewModel().thumbnail(image);
        }
        this.caller.imagePicker.editImage(image);
    }

    closeImage(target?, viewMode?) {
        this.caller.closeImage(target);
    }

    removeImage(target?, viewMode?) {
        this.caller.removeImage(target);
    }

    viewImage(target?, viewMode?) {
        this.caller.viewImage(target);
    }

    addImage(target?, viewMode?) {
        let image = null;
        if (target == "video_thumbnail") {
            image = this.thumbnailImageWidget.getImage();
            this.getTemplateViewModel().thumbnail(image);
        }
        this.caller.showImagePicker(viewMode, target);
    }

    clearFileInput() {
        let inputVideoUpload = document.getElementById("videoFileElement") as HTMLInputElement;
        inputVideoUpload.value = "";
    }

    saveVideo(param?) {
        this.parent.saveVideo(this.getVideo(), param);
    }

    isFormValid() {
        let valid = true;

        this.getTemplateViewModel().titleError(false);
        this.getTemplateViewModel().thumbnailError(false);

        let title = this.getTemplateViewModel().title();
        let image = this.thumbnailImageWidget.getImage();
        this.getTemplateViewModel().thumbnail(image);

        let thumbnail = this.getTemplateViewModel().thumbnail();

        if (title == "" || title == null) {
            this.getTemplateViewModel().titleError(true);
            valid = false;
        } else {
            this.getTemplateViewModel().titleError(false);
        }

        if (thumbnail == null || thumbnail == undefined) {
            this.getTemplateViewModel().thumbnailError(true);
            valid = false;
        } else {
            this.getTemplateViewModel().thumbnailError(false);
        }

        return valid;
    }

    resetFieldValidations() {
        this.getTemplateViewModel().titleError(false);
        this.getTemplateViewModel().thumbnailError(false);
    }

    formatBytes(bytes, decimals = 2) {
        if (!+bytes) return "0 Bytes";

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }

    setVideoCardElement(element) {
        this.getTemplateViewModel().videoCardElement(element);
    }

    getVideoCardElement(): any {
        return this.getTemplateViewModel().videoCardElement();
    }

    onClickPreviewVideo(data): any {
        window.open(data.url(), "_blank");
    }

    thumbnailUrl(): any {
        if (this.thumbnailImageWidget.getImage() != null) {
            const thumbnailImage = this.thumbnailImageWidget.getImage();
            return thumbnailImage.url;
        }
        return "";
    }

    onClickVideoPreview(data): any {
        window.open(data.url(), "_blank");
    }

    public setProducer(producer): void {
        if (producer) {
            this.getTemplateViewModel().producer(producer);
        }
        this.filterUser_producer.setUsers(producer);
    }

    public setIdProducer(idProducer): void {
        this.getTemplateViewModel().idProducer(idProducer);
    }

    public updateSelectedTags() {
        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObj();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find((t) => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if (tagSelected.tagType != null) {
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({ id: null, tag: tagSelected });
            }
        }

        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    protected setTagFilterAutocomplete(tags) {
        this.filterTag.getTemplateViewModel().tags(tags);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public setSelectedTags(selectedTags): void {
        selectedTags.forEach((t) => {
            let formattedTagTypeAndDataset = "";
            if (t.tag.type != null) {
                formattedTagTypeAndDataset = " (" + t.tag.type.name + ")";
            }

            if (!t.tag["formattedTagTypeAndDataset"]) {
                t.tag["formattedTagTypeAndDataset"] = formattedTagTypeAndDataset;
            }
        });

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected onClickDeleteSelectedTag(data) {
        let idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();
        let selectedTags = this.getTemplateViewModel().selectedTags();
        let index = selectedTags.findIndex((i) => i.tag.id == data.tag.id);
        if (index != -1) {
            selectedTags.splice(index, 1);
        }

        if (idPrimaryTag == data.tag.id) {
            this.getTemplateViewModel().idPrimaryTag(null);
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected setSelectedPrimaryTag(data) {
        this.getTemplateViewModel().idPrimaryTag(data.tag.id);
        //console.log(this.getTemplateViewModel().idPrimaryTag());
    }

    public updateSelectedCategories() {
        let selectedFilterCategories = this.filterCategory.getSelectedItems();
        let categories = this.getTemplateViewModel().categories();
        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();

        let categoryList = [];

        //build list of the categories that are now selected in the filter
        for (let idCategory of selectedFilterCategories) {
            let category = categories.find((c) => c.id == idCategory);
            if (category) {
                categoryList.push(category);
            }
        }

        let selectedCats = this.getTemplateViewModel().selectedCategories();

        //add categories that have not yet been selected
        for (let cat of categoryList) {
            let existingCategory = selectedCats.find((c) => c.category.id == cat.id);

            if (!existingCategory) {
                selectedCats.push({ id: null, category: cat });
            }
        }

        for (let i = selectedCats.length - 1; i >= 0; i--) {
            let catToRemove = categoryList.find((c) => c.id == selectedCats[i].category.id);
            if (!catToRemove) {
                selectedCats.splice(i, 1);
            }
        }

        //check if primary category still exists
        let primaryCategory = selectedCats.find((c) => c.category.id == idPrimaryCategory);
        if (!primaryCategory) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories([]);
        this.getTemplateViewModel().selectedCategories(selectedCats);
    }

    protected onClickDeleteSelectedCategory(data) {
        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();
        let allCategories = this.getTemplateViewModel().categories();
        let selectedCategories = this.getTemplateViewModel().selectedCategories();
        let index = selectedCategories.findIndex((i) => i.category.id == data.category.id);
        if (index != -1) {
            selectedCategories.splice(index, 1);
        }

        if (idPrimaryCategory == data.category.id) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories(selectedCategories);

        let selectedFilterCategories = this.filterCategory.getSelectedItems();

        index = selectedFilterCategories.findIndex((i) => i == data.category.id);
        if (index != -1) {
            selectedFilterCategories.splice(index, 1);
        }

        let updatedCats = [];
        for (let idCat of selectedFilterCategories) {
            let cat = allCategories.find((c) => c.id == idCat);
            if (cat) {
                updatedCats.push(cat);
            }
        }

        this.filterCategory.setSelectedItems(updatedCats);
    }

    public setSelectedCategories(categories): void {
        let selectedCategories = [];
        selectedCategories = categories.map((e) => e.category);
        this.filterCategory.setSelectedItems(selectedCategories);
        this.getTemplateViewModel().selectedCategories(categories);
    }

    public setIdPrimaryCategory(idPrimaryCategory): void {
        this.getTemplateViewModel().idPrimaryCategory(idPrimaryCategory);
    }

    public setCategories(items) {
        this.getTemplateViewModel().categories(items);
        this.filterCategory.setItems(items);
    }

    public setContentTypes(contentTypes: Array<{}>): void {
        this.getTemplateViewModel().contentTypes(contentTypes);
    }

    protected setSelectedPrimaryCategory(data) {
        this.getTemplateViewModel().idPrimaryCategory(data.category.id);
    }

    public setIdContentType(idContentType): void {
        this.getTemplateViewModel().idContentType(idContentType);
    }

    setValidationMessage(messages) {
        this.validations.setMessages(messages);
    }

    public setIsImageOptimized(val) {}

    public generateDropzoneSubtitles(videoSubtitles, extraInfo?) {
        let _this = this;

        if (myDropzone === null) {
            myDropzone = new Dropzone("div#my-drop-zone-2", {
                url: this.caller.getUploadUrlSubtitles(),
                maxFiles: null,
                acceptedFiles: ".vtt",
                clickable: true,
                maxFilesize: 1024 * 1024 * 1, // 1,048,576
                addRemoveLinks: false,
                dictRemoveFileConfirmation: "Are you sure you want to remove this subtitles file?",
                dictDefaultMessage: "",
                disablePreviews: true,
                previewsContainer: false
            });
        }

        myDropzone.removeAllFiles();
        myDropzone.files = [];

        myDropzone.on("success", function (file, fileInfo) {
            let subtitlesFiles = _this.getTemplateViewModel().subtitlesFiles();
            let addFile = true;
            let urlParsed = new URL(fileInfo.url);
            let subtitlesFile = {
                id: null,
                title: fileInfo.title,
                url: fileInfo.url,
                urlHuman: urlParsed.pathname,
                size: parseInt(fileInfo.size),
                sizeHuman: _this.formatBytes(fileInfo.size),
                mimeType: fileInfo.mimeType,
                idLanguage: null,
                type: null,
            };
            subtitlesFiles.forEach((sub) => {
                if (sub.url == subtitlesFile.url) {
                   addFile = false;
                }
            });
            if (addFile) {
                subtitlesFiles.push(subtitlesFile);
            }
            _this.getTemplateViewModel().subtitlesFiles(subtitlesFiles);
        });

        myDropzone.on("removedfile", function (file) {
            let url = file.name;
            if (file && file.xhr && file.xhr.response) {
                let response =  JSON.parse(file.xhr.response);
                url = response.url;
            }
            let subtitlesFiles = _this.getTemplateViewModel().subtitlesFiles();
            let filtered = subtitlesFiles.filter(function(el) { return el.url != url; });
            _this.getTemplateViewModel().subtitlesFiles(filtered);
        });

        myDropzone.on("error", function (file, message) {
            const elements = document.querySelectorAll(".dz-error-message span");
            const lastElement = elements[elements.length - 1];
            lastElement.textContent = message.validations[0].messages[0];
        });

        if (videoSubtitles && videoSubtitles.length > 0) {
            this.getTemplateViewModel().subtitlesFiles([]);
            let subtitlesFiles = [];
            videoSubtitles.forEach((fileInfo) => {
                if (fileInfo.id !== null) {
                    let urlHuman = "";
                    if (fileInfo.url == "auto-generated") {
                        urlHuman = "Queued for automatic generation";
                    } else {
                        let urlParsed = new URL(fileInfo.url);
                        urlHuman = urlParsed.pathname;
                    }
                    let subtitlesFile = {
                        id: fileInfo.id,
                        title: fileInfo.title,
                        url: fileInfo.url,
                        urlHuman: urlHuman,
                        size: parseInt(fileInfo.size),
                        sizeHuman: _this.formatBytes(fileInfo.size),
                        mimeType: fileInfo.mimeType,
                        idLanguage: fileInfo.idLanguage,
                        type: fileInfo.type,
                    };
                    subtitlesFiles.push(subtitlesFile);
                    let mockFile = { name: fileInfo.url, size: parseInt(fileInfo.size) };
                    myDropzone.emit("addedfile", mockFile);
                    myDropzone.createThumbnailFromUrl(mockFile, mockFile.name);
                    myDropzone.emit("complete", mockFile);
                    myDropzone.files.push(mockFile);
                }
            });

            this.getTemplateViewModel().subtitlesFiles(subtitlesFiles);
        } else {

            const defaultSubtitlesFiles = extraInfo == "NEW_VIDEO_UPLOADED" ?
                [{ id: null,
                    title: "auto-generated",
                    url: "auto-generated",
                    urlHuman: "Queued for automatic generation",
                    size: 0,
                    sizeHuman: _this.formatBytes(0),
                    mimeType: "text/vtt",
                    idLanguage: 1,
                    type: "Non-SDH",
                }] :
                [] ;
            this.getTemplateViewModel().subtitlesFiles(defaultSubtitlesFiles);
        }
    }

    public setSubtitlesLanguages(subtitlesLanguages): void {
        let subtitlesLanguagesNew = [];
        subtitlesLanguages.forEach((language) => {
            subtitlesLanguagesNew.push({ id: language.id, name: language.name, disable: ko.observable(language.name !== "English") });
        })
        this.getTemplateViewModel().subtitlesLanguages(subtitlesLanguagesNew);
    }

    protected deleteSubtitle(data) {
        if (confirm("Are you sure you want to remove this subtitles file?") === true) {
            data.name = data.url;
            let subtitlesFiles = this.getTemplateViewModel().subtitlesFiles();
            let filtered = subtitlesFiles.filter(function(el) { return el.url != data.url; });
            this.getTemplateViewModel().subtitlesFiles(filtered);
        }
    }


    protected downloadSubtitle(url){
        this.parent.downloadSubtitle(url)
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/videoPickerEdit_template.ts